<template>
  <v-app>
    <v-img
      class="login-image"
    >
      <v-container
        class="fill-height"
        fluid
      >
        <v-app-bar
          flat
          color="transparent"
        >
          <v-list-item-avatar
            class="align-self-center"
            contain
          >
            <v-img
              src="favicon.png"
              max-height="100%"
            />
          </v-list-item-avatar>
          <v-toolbar-title class="text-h4">
            {{ $t('avatar') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            text
            color="#fff"
            class="v-btn--active"
            href="/reset-password"
          >
            <v-icon
              class="mr-1"
            >
              mdi-lock-reset
            </v-icon>
            Reset Password
          </v-btn>
        </v-app-bar>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Account</v-toolbar-title>
              </v-toolbar>
              <v-progress-linear
                color="success"
                :class="{hidden: !loading }"
                indeterminate
              />
              <v-card-text>
                <v-text-field
                  ref="username"
                  v-model="username"
                  label="Username"
                  prepend-icon="mdi-account-circle"
                  type="text"
                  :rules="[
                    v => !!v || 'This is required'
                  ]"
                  @keydown.enter="$refs.password.focus()"
                />

                <v-text-field
                  ref="password"
                  v-model="password"
                  label="Password"
                  prepend-icon="mdi-lock"
                  type="password"
                  :maxlength="20"
                  :rules="[
                    v => !!v || 'This is required'
                  ]"
                  @keydown.enter.prevent="Login"
                />
              </v-card-text>
              <div
                class="px-12 text-body-1 error--text"
                :class="{hidden: !error }"
              >
                {{ error_text }}
              </div>
              <v-card-actions>
                <v-col>
                  <v-row class="px-3">
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      class="v-btn--active"
                      :disabled="loading"
                      @click="Login"
                    >
                      Login
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
              <br>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          align="center"
          no-gutters
        >
          <v-spacer class="hidden-sm-and-down" />
          <v-col
            cols="12"
            md="auto"
            class="mr-6"
          >
            <div class="footer text-center">
              Copyright &copy; 2026 - <a href="/">McDonald's Philippines</a>.
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <!-- OTP dialog -->
    <v-dialog
      v-model="mfa_required"
      :retain-focus="false"
      dense
      fixed
      style="margin: 0px !important;"
    >
      <v-card
        class="py-8 px-6 text-center mx-auto ma-4"
        elevation="4"
        max-width="400"
        width="100%"
      >
        <h3 class="text-title-large mt-0 mb-4 primary--text">
          Verify Your Account
        </h3>
        <br>
        <div class="text-body-medium">
          We've sent a 6-digit verification code to your email. <br>

          Please check your inbox and enter the code below. <br><br>
        </div>

        <v-sheet color="surface">
          <v-otp-input
            v-model="otp"
            type="number"
            length="6"
            :disabled="loading"
            :error="error"
            @finish="VerifyOTP"
          />
          <v-overlay
            absolute
            :value="loading"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </v-overlay>
        </v-sheet>

        <v-btn
          class="my-4"
          :color="OTPStatusColor()"
          height="40"
          text="Verify"
          variant="flat"
          width="70%"
        >
          <span
            v-if="error && !otp_success"
          >
            Validation Failed
          </span>
          <span
            v-if="otp_success"
          >
            Validation Successful
          </span>
        </v-btn>

        <div class="text-body-small">
          Didn't receive the code?
          <v-btn
            text
            color="primary"
            :disabled="disable_resend_otp"
            @click="ResendOTP"
          >
            Resend
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-- End OTP dialog -->
  </v-app>
</template>
<style scoped>
  .footer, .footer a, .text-h4 {
    color: #fff !important;
    font-weight: 400 !important;
  }
  .v-dialog {
    margin: 0px !important;
  }
</style>
<script>
  // rebuild
  import { Login, VerifyOTP, ResendOTP } from '@/graphql/Auth.gql'
  import { onLogin } from './vue-apollo'
  import { onLogout } from '@/vue-apollo'
  export default {
    data () {
      return {
        username: '',
        password: '',
        loading: false,
        error: false,
        error_text: '',
        default_error: 'Authentication failed.',
        otp: '',
        otp_form: false,
        otp_success: false,
        mfa_id: '',
        mfa_required: false,
        disable_resend_otp: true,
      }
    },
    mounted () {
      onLogout(this.$apollo.provider.defaultClient)
      this.$refs.username.focus()
    },
    methods: {
      OTPStatusColor () {
        return this.otp_success === true ? 'success' : 'error'
      },
      Login () {
        if (this.username === '' || this.password === '') { return }
        if (this.loading) { return }
        this.error_text = this.default_error
        this.loading = true
        this.error = false
        this.$apollo.mutate({
          mutation: Login,
          variables: {
            input: {
              username: this.username,
              password: this.password,
            },
          },
        }).then((res) => {
          this.loading = false
          if (res.data.Login.mfa_required) {
            this.otp = ''
            this.mfa_required = true
            this.mfa_id = res.data.Login.mfa_id
            //
            setTimeout(() => { this.disable_resend_otp = false }, 60000)
          } else if (res.data.Login.status === 'Ok' && res.data.Login.access_token !== '') {
            onLogin(this.$apollo.provider.defaultClient, res.data.Login.access_token)
            this.$router.push('/')
          } else {
            this.error = true
          }
        }).catch(error => {
          this.loading = false
          this.error = (error)
          if (error.networkError && error.networkError.statusCode === 504) {
            this.error_text = 'Request timeout.'
          } else {
            this.error_text = 'An error has occurred!'
          }
        })
      },
      VerifyOTP (code) {
        if (this.mfa_id === '' || code === '') { return }
        if (this.loading) { return }
        this.error_text = this.default_error
        this.loading = true
        this.error = false
        this.$apollo.mutate({
          mutation: VerifyOTP,
          variables: {
            input: {
              mfa_id: this.mfa_id,
              code: code,
            },
          },
        }).then((res) => {
          this.loading = false
          this.disable_resend_otp = true
          if (res.data.VerifyOTP.status === 'Ok') {
            // if verified, relogin
            this.error = false
            this.otp_success = true
            setTimeout(() => { this.Login() }, 2000)
          } else {
            this.mfa_id = ''
            this.error = true
            this.otp_success = false
            setTimeout(() => { this.mfa_required = false }, 2000)
          }
        }).catch(error => {
          this.loading = false
          this.error = (error)
          if (error.networkError && error.networkError.statusCode === 504) {
            this.error_text = 'Request timeout.'
          } else {
            this.error_text = 'An error has occurred!'
          }
        })
      },
      ResendOTP () {
        if (this.mfa_id === '') { return }
        if (this.loading) { return }
        this.disable_resend_otp = true
        this.$apollo.mutate({
          mutation: ResendOTP,
          variables: {
            input: {
              mfa_id: this.mfa_id,
            },
          },
        })
      },
    },
  }
</script>
